export const TEXT = {
  APP_STORE_ID: '1439872423',
  GLOBAL_BRAND_NAME: 'Nykaa Fashion',
  IOS_ACTION_URL_PREFIX: 'nykaafashion:/',
};

export const WIDGET_TYPES = {
  PAIR_IT_WITH: 'pair_it_with',
  SIMILAR_PRODUCTS: 'similar_products',
  MORE_FROM_BRAND: 'more_from_brand',
  MORE_FROM_CATEGORY: 'more_from_category',
  CUSTOMER_ALSO_VIEWED: 'cav',
  RECENTLY_VIEWED: 'recently_viewed',
  BANNER: 'banner',
};

export const PRODUCT_INFO_TITLE = 'Product Information';

export const ALL_INCLUSIVE_TEXTS = {
  MRP: 'MRP',
  INCLUSIVE: 'Inclusive of all taxes',
  INCLUSIVE_HALF: 'Incl. of taxes',
};

export const URGENCY_NUDGE_REMOTE_CONFIG = 'urgencyNudge';
export const WIDGET_RC_PDP_BANNER_WIDGET = 'pdp_banner_widget';
export const URGENCY_ARROW_SIZE = '16px';
export const URGENCY_ARROW_COLOR = '#C83602';
export const URGENCY_DEFAULT_CONFIG = {
  mweb: false,
  dweb: false,
  textColor: '',
};
export const BAG_UPDATED_SUCCESSFULLY = 'Bag Updated Successfully';
export const URGENCY_ANIMATION_BUFFER = 5000;
export const CONFIRM_BUTTON = 'Confirm';


export const PINK_FRIDAY_PRICE_TEXT = 'Pink Friday Price';